import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import { useState } from "react";

interface TransferWorkflowDialogProps {
    open: boolean;
    workflowId: string;
    workflowName: string;
    onClose: () => void;
    onTransfer: (targetEmail: string) => void;
}

const TransferWorkflowDialog = ({ 
    open, 
    workflowId, 
    workflowName, 
    onClose, 
    onTransfer 
}: TransferWorkflowDialogProps) => {
    const [targetEmail, setTargetEmail] = useState('');
    const [error, setError] = useState('');

    const handleTransfer = () => {
        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!targetEmail.trim()) {
            setError('Please enter an email address');
            return;
        }
        if (!emailRegex.test(targetEmail)) {
            setError('Please enter a valid email address');
            return;
        }
        
        onTransfer(targetEmail);
        handleClose();
    };

    const handleClose = () => {
        setTargetEmail('');
        setError('');
        onClose();
    };

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Transfer Workflow</DialogTitle>
            <DialogContent>
                <div className="mb-4">
                    <p className="text-sm mb-4" style={{ color: '#5f6368' }}>
                        ID: {workflowId}
                    </p>
                </div>

                <TextField
                    autoFocus
                    margin="dense"
                    label="Target User Email"
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={targetEmail}
                    onChange={(e) => {
                        setTargetEmail(e.target.value);
                        setError('');
                    }}
                    error={!!error}
                    helperText={error}
                    placeholder="user@example.com"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    Cancel
                </Button>
                <Button 
                    onClick={handleTransfer} 
                    variant="contained" 
                    color="primary"
                    disabled={!targetEmail.trim()}
                >
                    Transfer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TransferWorkflowDialog;

